import React, { useEffect, useState } from "react";
import { OAuthProvider, getRedirectResult, onAuthStateChanged, signInWithPopup, signInWithRedirect } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { LineWave } from "react-loader-spinner";
import { auth } from "./firebase";
import './Login.css';

const LOGIN_DESTINATION = "/dashboard";

const Login = () => {
    const navigate = useNavigate();
    const [isCheckingAuth, setIsCheckingAuth] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState("");
    const isLocalhost =
        typeof window !== "undefined" &&
        (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
    useEffect(() => {
        let isMounted = true;

        getRedirectResult(auth).catch((redirectError) => {
            if (isMounted) {
                console.error("Error completing Microsoft sign-in:", redirectError);
                setError(redirectError.message || "Microsoft sign-in could not be completed.");
                setIsCheckingAuth(false);
                setIsSubmitting(false);
            }
        });

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                sessionStorage.removeItem("fieldopsRedirect");
                navigate(LOGIN_DESTINATION, { replace: true });
            } else if (isMounted) {
                setIsCheckingAuth(false);
                setIsSubmitting(false);
            }
        });

        return () => {
            isMounted = false;
            unsubscribe();
        };
    }, [navigate]);

    const handleMicrosoftLogin = async () => {
        setError("");
        setIsSubmitting(true);

        const provider = new OAuthProvider('microsoft.com');
        provider.setCustomParameters({
            prompt: "select_account",
            tenant: "a627c9b0-6c9c-420a-ad0c-d96aad184cf3",
        });

        try {
            sessionStorage.removeItem("fieldopsRedirect");

            if (isLocalhost) {
                await signInWithPopup(auth, provider);
                navigate(LOGIN_DESTINATION, { replace: true });
                return;
            }

            await signInWithRedirect(auth, provider);
        } catch (error) {
            console.error("Error during Microsoft sign-in:", error);
            setError(error.message || "Microsoft sign-in could not be started.");
            setIsSubmitting(false);
        }
    };

    return (
        <div className="login-container">
            {isCheckingAuth ? (
                <div className="login-loading-shell">
                    <div className="login-loading-card">
                        <img src={require(`./abadata_logo_light.png`)} alt="AbaData logo" className="logo login-loading-logo" />
                        <LineWave
                            visible={true}
                            height="96"
                            width="96"
                            color="#FE8100"
                            ariaLabel="Checking sign-in status"
                        />
                        <p className="login-loading-title">Checking your sign-in status</p>
                        <p className="login-loading-copy">Verifying your access to the FieldOps portal.</p>
                    </div>
                </div>
            ) : (
                <>
            <section className="login-hero">
                <div className="login-hero-content">
                    <img src={require(`./abadata_logo_light.png`)} alt="AbaData logo" className="logo" />
                    <p className="eyebrow">Internal portal</p>
                    <h1 className="hero-title">AbaData FieldOps</h1>
                    <p className="hero-description">
                        Sign in with your AbaData Microsoft account to access app releases and logs.
                    </p>
                </div>
            </section>

            <section className="login-panel">
                <div className="login-box">
                    <p className="panel-kicker">Account access</p>
                    <h2 className="panel-title">Sign in with Microsoft</h2>
                    <p className="panel-description">
                        Use your AbaData Microsoft account to continue.
                    </p>

                    <button
                        onClick={handleMicrosoftLogin}
                        className="login-button"
                        disabled={isSubmitting}
                    >
                        <span className="microsoft-mark" aria-hidden="true">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                        {isSubmitting ? "Signing in…" : "Continue with Microsoft"}
                    </button>

                    {error ? <p className="login-error">{error}</p> : null}

                    <p className="login-help">
                        For sign-in assistance, contact the FieldOps team.
                    </p>
                </div>
            </section>
                </>
            )}
        </div>
    );
};

export default Login;
